var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkToContractSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 18,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 18,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 30V25C13 24.45 13.1958 23.9792 13.5875 23.5875C13.9792 23.1958 14.45 23 15 23H27C27.55 23 28.0208 23.1958 28.4125 23.5875C28.8042 23.9792 29 24.45 29 25V30H13ZM18 22C16.6167 22 15.4375 21.5125 14.4625 20.5375C13.4875 19.5625 13 18.3833 13 17C13 15.6167 13.4875 14.4375 14.4625 13.4625C15.4375 12.4875 16.6167 12 18 12H24C25.3833 12 26.5625 12.4875 27.5375 13.4625C28.5125 14.4375 29 15.6167 29 17C29 18.3833 28.5125 19.5625 27.5375 20.5375C26.5625 21.5125 25.3833 22 24 22H18ZM15 28H27V25H15V28ZM18 20H24C24.8333 20 25.5417 19.7083 26.125 19.125C26.7083 18.5417 27 17.8333 27 17C27 16.1667 26.7083 15.4583 26.125 14.875C25.5417 14.2917 24.8333 14 24 14H18C17.1667 14 16.4583 14.2917 15.875 14.875C15.2917 15.4583 15 16.1667 15 17C15 17.8333 15.2917 18.5417 15.875 19.125C16.4583 19.7083 17.1667 20 18 20ZM18 18C18.2833 18 18.5208 17.9042 18.7125 17.7125C18.9042 17.5208 19 17.2833 19 17C19 16.7167 18.9042 16.4792 18.7125 16.2875C18.5208 16.0958 18.2833 16 18 16C17.7167 16 17.4792 16.0958 17.2875 16.2875C17.0958 16.4792 17 16.7167 17 17C17 17.2833 17.0958 17.5208 17.2875 17.7125C17.4792 17.9042 17.7167 18 18 18ZM24 18C24.2833 18 24.5208 17.9042 24.7125 17.7125C24.9042 17.5208 25 17.2833 25 17C25 16.7167 24.9042 16.4792 24.7125 16.2875C24.5208 16.0958 24.2833 16 24 16C23.7167 16 23.4792 16.0958 23.2875 16.2875C23.0958 16.4792 23 16.7167 23 17C23 17.2833 23.0958 17.5208 23.2875 17.7125C23.4792 17.9042 23.7167 18 24 18Z",
    fill: "#3474E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToContractSelected);
export default __webpack_public_path__ + "static/media/talk_to_contract_selected.e46486e46ac2c32cbaadf826ed1e6f7c.svg";
export { ForwardRef as ReactComponent };